<template>
	<div>
        <div class="card">
            <div class="header">
                <h2>
                    <strong>{{ $t('documents') }}</strong>
                    <span>&nbsp;{{ $t('available') }}</span>
                    <span class="badge badge-default text-light ml-1">{{numDocs}}</span>
                </h2>
            </div>
            <div class="body" :class="{'pt-0':this.$Params.isMobile}">
                <mmTabla :items="items" :itemsPerPage="15" :headers="fields" :mobile="true" :placeholderBusquedaRapidaProp="$t('busquedaRapida')"
                    :placeholderBusquedaProp="$t('busqueda')" :noResultsProp="$t('noResults')">
                    <template v-slot:cell(fecha)="data">
                        {{ formatFechaHora(data.item.fecha) }}
                    </template>
                    <template v-slot:cell(actions)="data">
                        <div>
                            <mmButton type="download" classe="ml-1" :click="()=>downloadClick(data.item.entrada)" />
                        </div>
                    </template>
                    <template v-slot:mobile="row">
                            <div class="d-flex align-items-center">
                                <div class="mm-actions pr-3">
                                    <mmButton type="download" classe="ml-1" :click="()=>downloadClick(row.entrada)" />
                                </div>
                                <div>
                                    <b>{{$t('subject')}}:</b> {{row.tema}}<br>
                                    <b>{{$t('CCO')}}:</b> {{row.cco}}<br>
                                    <b>{{$t('classificationCode')}}:</b> {{row.cod_clasificacion}}<br>
                                    <b>{{$t('classificationSubcode')}}:</b> {{row.subcod_clasificacion}}<br>
                                    <b>{{$t('date')}}:</b> {{formatFechaHora(row.fecha)}}<br>
                                </div>
                            </div>
                        </template>
                </mmTabla>
            </div>
        </div>
        <ModalAuthenticator ref="authenticator" @getCode="getCodeAuthenticator" />
    </div>
</template>

<script>
    import ModalAuthenticator from '@/components/ModalAuthenticator.vue'
    import mmTabla from '@mysummar/summar-vue/src/components/mmTabla.vue'
    import mmButton from '@mysummar/summar-vue/src/components/mmButton.vue'
    import { documentService } from '../api/document';
    export default {
        name: 'Home',
        components: {
            mmTabla,
            mmButton,
            ModalAuthenticator
        },
        data() {
            return {
                items: [],
                numDocs: 0,
                fields: [
                    {
                        key: 'tema',
                        sortable: true,
                        label:  this.$i18n.t('subject') 
                    },
                    {
                        key: 'cco',
                        sortable: true,
                        label: this.$i18n.t('CCO') 
                    },
                    {
                        key: 'cod_clasificacion',
                        label: this.$i18n.t('classificationCode') ,
                        sortable: true,
                    },
                    {
                        key: 'subcod_clasificacion',
                        label: this.$i18n.t('classificationSubcode') ,
                        sortable: true,
                    },
                    {
                        key: 'fecha',
                        label: this.$i18n.t('date') ,
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: '',
                        search: false,
                        class: 'mm-actions'
                    }
                ],    
            }
        },
        methods: {
            getCodeAuthenticator(data) 
            {
                this.downloadAnexo(data.anexo, data.code);
            },
            downloadClick(idAnexo) {

                if(this.$Params.user_authenticator==1 && this.$Params.mfa_anexos==1)
                    this.$refs.authenticator.openModal({anexo: idAnexo});
                else
                    this.downloadAnexo(idAnexo);
            },
            async downloadAnexo(idAnexo, code) {
                
                let dataAnexo = await documentService.download(idAnexo, code);
                
                if(dataAnexo) {
                    //generacion de la descarga desde el navegador
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(new Blob([dataAnexo.file]))
                    link.setAttribute('download', dataAnexo.name)
                    document.body.appendChild(link)
                    link.click();
                }
            },
            formatFechaHora(fechaOriginal) {
                const fecha = new Date(fechaOriginal);

                const dia = fecha.getDate().toString().padStart(2, '0');
                const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); 
                const año = fecha.getFullYear();

                const fechaFormateada = `${dia}/${mes}/${año}`;

                return año != '1753' ? fechaFormateada : '';
            },
            
        },
        async created() {
            this.items = await documentService.getAll();
            this.numDocs = this.items.length;
        }
    }
</script>